// Auto generated file, do not manually modify!
// com.hotpads.rentpayment.handler.web.v1.ToggleFeatureWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type { ToggleFeatureRequestDto, ToggleFeatureResponseDto } from '../..';

export const ToggleFeatureWebApiHandler_toggleFeature_Path = '/api/web/v1/userFeature/toggleFeature';

/**
 * Toggle user feature
 */
export const ToggleFeatureWebApiHandler_toggleFeature = (postData: ToggleFeatureRequestDto, client = getClient()) => {
  return httpFrontEndRequest<never, ToggleFeatureRequestDto, ToggleFeatureResponseDto>(
    {
      endpoint: ToggleFeatureWebApiHandler_toggleFeature_Path,
      method: 'POST',
      contextPath: '/rent-payment',
      postData: postData,
    },
    client,
  );
};
